/* eslint-disable prettier/prettier */
import { Grid, makeStyles, Typography, Paper, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import { WithTrafiLayout } from './TrafiLayout';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { TextButton } from './solteq-react/forms/Buttons';
import authService from '../authService';
import AlertNotification from './AlertNotification';

const useFormStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            marginTop: '30px'
        }
    }
}));

const AccountLogin = () => {
    const formClasses = useFormStyles();
    // const valid = validate(formValues);
    const isBigTitleUsed = useMediaQuery('(min-width:500px)');
    const isExtraPaddingUsed = useMediaQuery('(min-width:1320px)');
    const isLeftRightAlignUsed = useMediaQuery('(min-width:1005px)');
    const isDescriptionShown = useMediaQuery('(min-height:730px)');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showForgotPassword, setShowForgotPassword] = useState(false);

    const ForgotPasswordView = () => {

        const [email, setEmail] = useState('');
        const [emailError, setEmailError] = useState('');
        const [notification, setNotification] = useState('');
//        const [emailSuccess, setEmailSuccess] = useState('');

        const validateEmail = (value) => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(value);
        };

        const handleSubmit = async () => {
            if (!validateEmail(email)) {
                setEmailError('Anna kelvollinen sähköpostiosoite.');
                setNotification('');
                return;
            }

            setEmailError('');

            // TODO: Call backend to send reset link
            const result = await authService.ForgotPassword(email);

            if (result === 'OK') {
                setNotification(`Salasanan palautuslinkki on lähetetty sähköpostiosoitteeseen ${email}`);
//                setEmailSuccess(`Salasanan palautuslinkki on lähetetty sähköpostiosoitteeseen ${email}`);
                setTimeout(() => {
                    setNotification('');
                    setShowForgotPassword(false);
                }, 4000); // Wait 4 seconds before hiding the view
            } else {
                setEmailError(result); // Display the error message
            }
        };

        return (
            <Paper
                style={{
                    paddingTop: '10px',
                    paddingLeft: '40px',
                    paddingRight: '40px',
                    paddingBottom: '40px',
                    margin: '20px',
                    backgroundColor: '#fafafa'
                }}
                elevation={0}
            >
                <Typography variant="h6">Unohtuiko salasana?</Typography>
                <Typography variant="body2" style={{ marginTop: '20px' }}>
                    Anna sähköpostiosoitteesi, niin lähetämme sähköpostin salasanan muuttamista varten.
                </Typography>
                <TextField
                    label="Sähköposti"
                    variant="outlined"
                    fullWidth
                    style={{ marginTop: '30px' }}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    error={!!emailError}
                    helperText={emailError || notification}
                    FormHelperTextProps={{
                        style: {
                            color: emailError ? '#f44336' : '#2196f3', // red for error, blue for success
                        },
                    }}
                />
                <TextButton
                    variant="contained"
                    color="secondary"
                    fullWidth
                    style={{ height: '64px', marginTop: '30px' }}
                    onClick={handleSubmit}
                >
                    Lähetä sähköposti
                </TextButton>
                <TextButton
                    variant="contained"
                    color="secondary"
                    fullWidth
                    style={{ height: '64px', marginTop: '30px' }}
                    onClick={() => setShowForgotPassword(false)}
                >
                    Takaisin kirjautumiseen
                </TextButton>
            </Paper>
        );
    };

    return (
        <>
            <footer style={{ position: 'absolute', bottom: '5px', width: '100%', textAlign: 'center' }}>
                <Typography style={{ color: 'white' }} variant="caption">
                    <br />
                    <b>Tietojen tekninen toimitus</b> Solteq Oyj, Revontulenkuja 1, 02100 Espoo
                </Typography>
            </footer>
            <div style={{ width: '100%' }}>
                <Grid container justifyContent="center">
                    <Grid item container direction="column" style={{ minWidth: 0, width: 'auto' }}>
                        <Grid item style={{ marginTop: '6%' }}>
                            <AlertNotification alertMessage={alertMessage} handleClose={() => setAlertMessage(undefined)} />
                        </Grid>
                        <Grid item style={{ marginTop: '4%' }} container direction={isLeftRightAlignUsed ? 'row' : 'column'} alignItems="center" justifyContent="center">
                            <Grid item style={{ marginRight: isExtraPaddingUsed ? '100px' : '0px' }}>
                                <Typography variant={isBigTitleUsed ? 'h2' : 'h4'} style={{ color: 'white', fontWeight: '600' }}>
                                    Ajoneuvokysely
                                </Typography>
                            </Grid>
                            <Grid item container direction="column" style={{ maxWidth: '513px' }}>
                                <Grid item>
                                    {showForgotPassword ? (
                                        <ForgotPasswordView />
                                    ) : (
                                    <Paper
                                        style={{
                                            paddingTop: '10px',
                                            paddingLeft: '40px',
                                            paddingRight: '40px',
                                            paddingBottom: '40px',
                                            margin: '20px',
                                            backgroundColor: '#fafafa'
                                        }}
                                        elevation={0}
                                    >
                                        <form
                                            className={formClasses.root}
                                            noValidate
                                            autoComplete="off"
                                            onSubmit={async (e) => {
                                                e.preventDefault();
                                                setIsLoading(true);
                                                authService.loginWithUsernameAndPassword(username, password).then((result) => {
                                                    if (result === 'OK') {
                                                        window.location.href = '/';
                                                    } else {
                                                        setIsLoading(false);
                                                        setAlertMessage(result);
                                                    }
                                                });
                                            }}
                                        >
                                            <TextField
                                                disabled={isLoading}
                                                label="Käyttäjätunnus"
                                                variant="outlined"
                                                fullWidth
                                                onChange={(e) => setUsername(e.target.value)}
                                            />
                                            <TextField
                                                disabled={isLoading}
                                                label="Salasana"
                                                variant="outlined"
                                                type="password"
                                                fullWidth
                                                onChange={(e) => setPassword(e.target.value)}
                                            />
                                            <div>
                                                <span
                                                    style={{ cursor: 'pointer', color: '#1976d2', textDecoration: 'underline' }}
                                                    onClick={() => setShowForgotPassword(true)}
                                                >
                                                    Unohtuiko salasana?
                                                </span>
                                            </div>
                                            <TextButton disabled={isLoading} variant="contained" color="secondary" fullWidth style={{ height: '64px' }} type="submit">
                                                {isLoading ? 'Kirjaudutaan...' : 'Kirjaudu sisään'}
                                            </TextButton>
                                          </form>
                                      </Paper>)}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item container justifyContent="flex-end" style={{ opacity: isDescriptionShown ? 100 : 0 }}>
                            <Grid item></Grid>
                            <Grid item style={{ maxWidth: '513px', paddingLeft: '20px', paddingRight: '20px' }}>
                                <Typography style={{ color: 'white', fontWeight: '500' }}>
                                    Solteqin ajoneuvokysely on väylä ajantasaisiin tietoihin kaikille autoalan toimijoille. Jotta voit käyttää ajoneuvokyselyä sinun tulee
                                    sopia palvelusopimus Solteq Oyj:n kanssa.
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </>
    );
};

const WrappedAccountLogin = WithTrafiLayout(AccountLogin, false);
export default WrappedAccountLogin;
